import React from 'react';
import { Link } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import EDSFooter from '../components/EDSFooter';
import { useSelector } from 'react-redux';

const Odzyskaj_konto_wyslane = () => {
    const key = useSelector((state) => state.repos.chName);
    let url = "/";
    if(key){
        url = '/key/'+ key.toString();
    }
 
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content responsive-padding">
                <div className="margin-top-32">
                    <a href="">
                        <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                    </a>
                </div>
                <main className="margin-top-64">
                    <div className="texts text-box">
                        <p>
                            <svg
                                className="account-recover-icon"
                                width="32"
                                height="32"
                                viewBox="0 0 281 281"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M273.333 98.3334H203.333L229.373 72.2934C218.917 58.6062 205.442 47.5181 189.998 39.8931C174.554 32.268 157.557 28.3121 140.333 28.3334C78.4533 28.3334 28.3333 78.4534 28.3333 140.333C28.3333 165.953 36.8733 189.333 51.2933 208.233C68.3733 188.633 100.433 175.333 140.333 175.333C180.233 175.333 212.433 188.633 229.373 208.233C244.309 188.754 252.382 164.88 252.333 140.333H280.333C280.333 217.333 217.333 280.333 140.333 280.333C63.3333 280.333 0.333344 217.333 0.333344 140.333C0.333344 63.3334 63.3333 0.333374 140.333 0.333374C184.293 0.333374 223.633 20.6334 249.253 52.4134L273.333 28.3334V98.3334ZM140.333 70.3334C163.573 70.3334 182.333 89.0934 182.333 112.333C182.333 135.573 163.573 154.333 140.333 154.333C117.093 154.333 98.3333 135.573 98.3333 112.333C98.3333 89.0934 117.093 70.3334 140.333 70.3334Z" />
                            </svg>
                        </p>
                        <p className="margin-top-8">Na adres</p>
                        <p id="account-recover-email" className="text-large fw-700 margin-top-8">
                            {localStorage.getItem('odzyskajLogin')}
                        </p>
                        <p className="margin-top-8">
                            wyslaliśmy wiadomość zawierającą link do aktywacji hasła.
                        </p>
                        <p>Postępuj zgodnie z instrukcjami zawartymi w mailu.</p>
                        <Link to={url}>
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-64"
                            >
                                Wróć do strony głównej
                            </a>
                        </Link>
                    </div>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Odzyskaj_konto_wyslane;
